import { useEffect } from 'react';
import styles from "../styles.module.css";

const MaterialComponent = ({ passData, returnClick, fenceType}) => {

  const autoTypes = ["Chainlink", "Deer", "Aluminum"];

  useEffect(() => {
    if (fenceType === "Chainlink" || fenceType === "Deer") passData("Steel");
    if (fenceType === "Aluminum") passData("Aluminum");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fenceType]);

  // If this fenceType auto-selects, render nothing (useEffect handles it)
  if (autoTypes.includes(fenceType)) return null;

  return (
    <div style={{ paddingBottom: "80px" }}>
      <div id="fenceTypes">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingBottom: "30px" }}>
          <h1 style={{color: 'maroon'}}>Select Fence Material</h1>
            <div style={{ textAlign: "center", display: 'flex', justifyContent: 'flex-start' }}>
                <button className={styles.Button} onClick={() => returnClick("fenceMaterial")}>Return</button>
            </div>
        </div>
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <div style={{display: 'flex', flexDirection: 'column', gap: '20px', width: '150px'}}>
            <button className={styles.Button2} onClick={() => passData("Hollow Vinyl")}>Hollow Vinyl</button>
            <button className={styles.Button2} onClick={() => passData("Solid Vinyl")}>Solid Vinyl</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MaterialComponent;